export default __webpack_public_path__ + "static/media/driver_accepted.df93b7a3.svg";